import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { GestorClientesFilters } from '@/components/Gestores/GestorClientesFilters'
import { GestorClientesTable } from '@/components/Gestores/GestorClientesTable'
import { GestorEquipeTab } from '@/components/Gestores/GestorEquipeTab'
import { GestorChamadosTab } from '@/components/Gestores/GestorChamadosTab'
import { GestorEntradasTab } from '@/components/Gestores/GestorEntradasTab'
import { GestorDashboardTab } from '@/components/Gestores/GestorDashboardTab'
import { GestorClienteDetailModal } from '@/components/Gestores/GestorClienteDetailModal'
import { GestorJornadaTab } from '@/components/Gestores/GestorJornadaTab'
import { GestorSolicitacoesTab } from '@/components/Gestores/GestorSolicitacoesTab'
import { GestoresTopbar } from '@/components/Gestores/GestoresTopbar'
import { FinanceRequestFormModal } from '@/components/Financeiro/solicitacoes/FinanceRequestFormModal'
import { useGestoresPage } from '@/hooks/useGestoresPage'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { canAccessGestoresModule, canAccessGestorMarketingDashboard } from '@/config/gestorAccess'
import { getRoleFallbackPath } from '@/config/routeAccess'

export default function Gestores() {
  const user = useAuthStore((s) => s.user)
  const page = useGestoresPage()

  if (!user || !canAccessGestoresModule(user)) {
    return <Navigate to={user ? getRoleFallbackPath(user.role, '/gestores', user) : '/login'} replace />
  }

  const showDashboard = canAccessGestorMarketingDashboard(user)

  const loading =
    page.tab === 'dashboard'
      ? false
      : page.tab === 'clientes'
      ? page.clientesLoading
      : page.tab === 'equipe'
        ? page.equipeLoading
        : page.tab === 'chamados'
          ? page.chamadosLoading
          : page.tab === 'entradas'
            ? page.entradasLoading
            : page.tab === 'jornada'
              ? page.jornadaLoading
            : false
  const reload =
    page.tab === 'dashboard'
      ? page.reloadDashboard
      : page.tab === 'clientes'
      ? page.loadClientes
      : page.tab === 'equipe'
        ? page.loadEquipe
        : page.tab === 'chamados'
          ? page.loadChamados
          : page.tab === 'entradas'
            ? page.loadEntradas
            : page.tab === 'jornada'
              ? page.reloadJornada
            : () => undefined

  return (
    <DashboardLayout title='Gestores Agrada'>
      <GestoresTopbar
        tab={page.tab}
        setTab={page.setTab}
        loading={loading}
        onReload={() => void reload()}
        showDashboard={showDashboard}
      />

      {page.tab === 'dashboard' && showDashboard && (
        <GestorDashboardTab reloadToken={page.dashboardReloadKey} />
      )}

      {page.tab === 'dashboard' && !showDashboard && (
        <Navigate to='/gestores?tab=clientes' replace />
      )}

      {page.tab === 'clientes' && (
        <div className='space-y-3'>
          <GestorClientesFilters
            search={page.clienteSearch}
            onSearchChange={page.setClienteSearch}
          />
          <GestorClientesTable
            clientes={page.clientes}
            loading={page.clientesLoading}
            onSelect={(id) => void page.openCliente(id)}
          />
        </div>
      )}

      {page.tab === 'equipe' && (
        <GestorEquipeTab
          equipe={page.equipe}
          loading={page.equipeLoading}
          search={page.equipeSearch}
          onSearchChange={page.setEquipeSearch}
          onSelect={page.openEquipeMember}
          initialView={page.equipeView}
          onViewChange={page.setEquipeView}
        />
      )}

      {page.tab === 'jornada' && (
        <GestorJornadaTab
          reloadKey={page.jornadaReloadKey}
          search={page.jornadaSearch}
          setSearch={page.setJornadaSearch}
        />
      )}

      {page.tab === 'solicitacoes' && (
        <GestorSolicitacoesTab
          items={page.solicitationCards.map((item) => ({
            key: item.key,
            title: item.title,
            description: item.description,
          }))}
          onSelect={page.setSelectedType}
        />
      )}

      {page.tab === 'entradas' && (
        <GestorEntradasTab
          entradas={page.entradas}
          loading={page.entradasLoading}
          error={page.entradasError}
          search={page.entradasSearch}
          onSearchChange={page.setEntradasSearch}
          statusFilter={page.entradasStatus}
          setStatusFilter={page.setEntradasStatus}
          onSelect={page.openEntrada}
        />
      )}

      {page.tab === 'chamados' && (
        <GestorChamadosTab
          requests={page.chamados}
          loading={page.chamadosLoading}
          error={page.chamadosError}
          typeLabels={page.typeLabels}
          queueLifecycle={page.chamadosLifecycle}
          setQueueLifecycle={page.setChamadosLifecycle}
          queueSearch={page.chamadosSearch}
          setQueueSearch={page.setChamadosSearch}
          queueArea={page.chamadosArea}
          setQueueArea={page.setChamadosArea}
          onSelect={page.openRequest}
        />
      )}

      <GestorClienteDetailModal
        open={Boolean(page.selectedClienteId)}
        loading={page.clienteDetailLoading}
        detail={page.clienteDetail}
        onClose={page.closeCliente}
      />

      {page.selectedCard && (
        <FinanceRequestFormModal
          type={page.selectedCard}
          open={Boolean(page.selectedType)}
          submitting={page.submitting}
          onClose={() => page.setSelectedType(null)}
          onSubmit={(formData, linkedEmpresaId, linkedDealId, attachments) => {
            if (!page.selectedType) return
            void page.submitRequest(
              page.selectedType,
              formData,
              linkedEmpresaId,
              linkedDealId,
              attachments,
            )
          }}
        />
      )}

    </DashboardLayout>
  )
}
